<script setup>
import { ref, onMounted, watch} from 'vue'
import { useRoute, useRouter } from 'vue-router'
/* import {ChartTypeEnum} from  "@/components/explorer/visualizations/ChartTypeEnum.js" */
/* import ToggleSwitch from '@/components/common/ToggleSwitch.vue'; */
import DropDown from "@/components/common/DropDownSelect.vue"

//properties set by parent
const props = defineProps({
	indicator: {
		type: Object,
		required: true,
	},
	categories: {
		type: Array,
		required: true
	},
	chartSettings: {
		type: Object,
		required: true
	}
}) 

//componenet methods exposed to parent


//events raised by component
const emit = defineEmits(["openFilters","updateChartType", "updateChartCategory"])

//reactive field proxies
/* const toggleHorizontalBar = ref(props.chartSettings.toggleHorizontalBar) */
/* const toggleStack = ref(props.chartSettings.toggleStack) */
const selectedXAxisCatName = ref('')
const selectedGrpCatName = ref('')
const xAxisCategories = ref([])
const xGrpCategories = ref([])

//local variables
let AllCats = []
let AllGrpCats = []
let xAxisExcludeList = []
let grpExcludeList = []

function setupFilters() {
	emit('openFilters');
}

function updateXaxis(dimName) {
	selectedXAxisCatName.value = dimName

	// tmpArr = AllCats.filter(cat => cat.columnName != selectedXAxisCatName.value)
	//xGrpCategories.value = tmpArr;

	//chartSettings = {...props.chartSettings}
	let chartSettings = props.chartSettings
	//set xaxis dim
	let xAxisDim = xAxisCategories.value.find(i => i.columnName == selectedXAxisCatName.value)
	let allVal = xAxisDim.totalLabel
	let found = xAxisDim.appliedValues.findIndex(i => i == allVal)
	
	//TODO: Refactor this logic out, could be handled by AppliedValues.buildRequest()?
	//for Year default to latest Year, TODO: replace this code with metadata.default value
	if(xAxisDim.columnName == "Year") {
		const lenAppliedValues = xAxisDim.appliedValues.length
		xAxisDim.appliedValues.forEach((i, x) => {
			//if no All then select last as default
			i.selected = x==(lenAppliedValues-1)?true:false;
		})
	} else {
		xAxisDim.appliedValues.forEach((i, x) => {
			if(allVal == null || found == -1) {
				//if no All then select 1st as default
				i.selected = x==0?false:true; 
			} else if(i.name == allVal)
				i.selected = false
			else
				i.selected = true
		})
	}
	//end of future refactor

	buildXAxisExcludeList()
	buildGrpExcludeList()	
	chartSettings.xAxisDim = xAxisDim
	emit('updateChartCategory', chartSettings);
}

function updateGroup(dimName) {
	selectedGrpCatName.value = dimName

	//reset selections for current cat so that ALL if it exists is the only true value 
	//let tmpArr = AllCats.filter(cat => cat.columnName != selectedGrpCatName.value)
	//xAxisCategories.value = tmpArr;	
	//chartSettings = {...props.chartSettings}
	let chartSettings = props.chartSettings

	//TODO: Possible refactor, this logic could be handled by AppliedValues.buildRequest()?
	//revert old selected category selections to false except ALL set to true
	let oldSeriesDim = chartSettings.seriesDim
	let allVal = oldSeriesDim.totalLabel	
	let found = oldSeriesDim.appliedValues.findIndex(i => i.name == allVal)

	//if old category is Year, default to latest Year, TODO: replace this code with metadata.default value
	/*if(oldSeriesDim.columnName == "Year") {
		oldSeriesDim.appliedValues.forEach((i) => {
			i.selected = false
		})
		oldSeriesDim.appliedValues[0].selected = true
	} else {*/
		oldSeriesDim.appliedValues.forEach((i, x) => {
			if(allVal == null || found == -1) {
				//if no All then select 1st as default
				i.selected = x==0?true:false; 
			} else if(i.name == allVal)
				i.selected = true
			else
				i.selected = false
		})
	//}
	//end of future refactor

	let seriesDim = xGrpCategories.value.find(i => i.columnName == selectedGrpCatName.value)

	//TODO: Possible refactor, this logic could be handled by AppliedValues.buildRequest()?
	allVal = seriesDim.totalLabel	
	found = seriesDim.appliedValues.findIndex(i => i.name == allVal)
	//for Year default to latest Year, TODO: replace this code with metadata.default value
	/*if(seriesDim.columnName == "Year") {
		seriesDim.appliedValues.forEach((i) => {
			i.selected = true
		})
		seriesDim.appliedValues[0].selected = false
	} else {*/
		seriesDim.appliedValues.forEach((i, x) => {
			if(allVal == null || found == -1) {
				//if no All then select 1st as default
				i.selected = x==0?true:false; 
			} else if(i.name == allVal)
				i.selected = false
			else
				i.selected = true
		})
	//}
	//end of future refactor

	buildXAxisExcludeList()
	buildGrpExcludeList()		
	//set xaxis series (or group) dim
	chartSettings.seriesDim = seriesDim
	emit('updateChartCategory', chartSettings);
}


onMounted(() => {

	if(props.chartSettings && props.chartSettings.xAxisDim) {
		AllCats = props.categories.filter(cat => { 
			if(cat.sankeyFlag == 1 && cat.columnName !== 'Year' && cat.childColumnName == null) {
				return cat
			}
		})
		AllGrpCats = props.categories.filter(cat => {			
			if(cat.categoryLabelFlag == 1 && cat.columnName !== 'Year' && cat.childColumnName == null) {
				return cat
			}
		})
	
		xAxisCategories.value = AllCats
		xGrpCategories.value = AllGrpCats			
		selectedXAxisCatName.value = props.chartSettings.xAxisDim.columnName
		selectedGrpCatName.value = props.chartSettings.seriesDim.columnName			
		buildXAxisExcludeList()
		buildGrpExcludeList()
	}

	watch(props, (newProps) => {
		
		AllCats = newProps.categories.filter(cat => { 
			if(cat.sankeyFlag == 1 && cat.columnName !== 'Year' && cat.childColumnName == null) {
				return cat
			}
		})
		AllGrpCats = newProps.categories.filter(cat => {			
			if(cat.categoryLabelFlag == 1 && cat.columnName !== 'Year' && cat.childColumnName == null) {
				return cat
			}
		})
		xAxisCategories.value = AllCats
		xGrpCategories.value = AllGrpCats	
		selectedXAxisCatName.value = newProps.chartSettings.xAxisDim.columnName
		selectedGrpCatName.value = newProps.chartSettings.seriesDim.columnName						
		buildXAxisExcludeList()
		buildGrpExcludeList()

	})
});

function buildXAxisExcludeList() {
	//Do not allow XAxisCat to be child of GrpCat
	xAxisExcludeList = AllCats.filter(cat => {
		if(cat.columnName == selectedGrpCatName.value || 
		(cat.childColumnName != null && cat.childColumnName == selectedGrpCatName.value)) {
			return true;
		}
	}).map(item => item.columnName)


}
function buildGrpExcludeList() {
	//Do not allow GrpCat to be a parent of XAxisCat
	grpExcludeList = AllGrpCats.filter(cat => {
		if(cat.columnName == selectedXAxisCatName.value ||
		(cat.parentColumnName != null && cat.parentColumnName == selectedXAxisCatName.value)) {
			return true;
		}
	}).map(item => item.columnName)	
}
//Do not allow selectedGrpCatName to be a parent OR child of selectedXAxisCatName or Year:
/* watch([selectedXAxisCatName,selectedGrpCatName],([newXvalue,newGrpValue], [oldXvalue,oldGrpValue]) => {
	//console.log("------WATCH------------------")
	//console.log(newXvalue,newGrpValue)
	const group = props.categories.filter(cat => { 
		if(cat.columnName === newXvalue && (cat.childColumnName === newGrpValue || cat.parentColumnName === newGrpValue)) {
			return cat
		}
	});
	if(group.length) {
		//console.log('-UPDATING GROUP-')
		const AllCats = props.categories.filter(cat => { 
			if(cat.sankeyFlag == 1 && cat.columnName !== 'Year' && cat.columnName !== newXvalue && cat.childColumnName !== selectedXAxisCatName.value && cat.parentColumnName !== selectedXAxisCatName.value) {
				return cat
			}
		})
		//console.log('AllGrpCats[0].columnName',AllGrpCats[0].columnName)
		updateXaxis(AllCats[0].columnName)
	}
}); */
/*watch(props,(newValue, oldValue) => {
	if(props.chartSettings && props.chartSettings.xAxisDim && props.chartSettings.seriesDim) {
		//if(newValue != oldValue && oldValue != "") {	
		chartSettings = {...props.chartSettings}
		//if(newValue != oldValue && oldValue != "") {
						
			selectedXAxisCatName.value = props.chartSettings.xAxisDim.columnName
			selectedGrpCatName.value = props.chartSettings.seriesDim.columnName	
			xAxisCategories.value = AllCats.filter(cat => cat.columnName !== selectedGrpCatName.value)
			xGrpCategories.value = AllGrpCats.filter(cat => cat.columnName !== selectedXAxisCatName.value)
		//}
	}
})*/

</script>

<template>
	<div class="chart-options">

		<div class="chart-options-row">
			<div class="chart-options-col">
				<div>
					<div class="subtle-label">Left</div>
				</div>
				<div>
					<DropDown v-model="selectedGrpCatName" :list="xGrpCategories" :keyField="'columnName'" @selectedDropdown="updateGroup" :disableFields="grpExcludeList" />				
				</div>
			</div>

			<div class="chart-options-col">
				<div>
					<div class="subtle-label">Right</div>
				</div>
				<div>
					<DropDown v-model="selectedXAxisCatName" :list="xAxisCategories" :keyField="'columnName'" @selectedDropdown="updateXaxis" :disableFields="xAxisExcludeList" />
				</div>
			</div>
			<div class="chart-options-col bottom">
				<button @click="setupFilters" class="btn-tertiary"><span class="icon-settings">
					<i class="fa-regular fa-sliders"></i></span>Customize chart</button>
			</div>			
		</div>
	</div>
</template>

<style scoped>
.chart-options {
	display:flex;
	flex-direction: row;
	justify-content:space-between;
	margin: 1.5rem 1.25rem 0.25rem 1.25rem;	
}

.chart-options-row {
	display:flex;
	flex-direction: row;
	column-gap: var(--spacing-lg);
}

.chart-options-col .start {
	display:flex;
	justify-content: start;
}

.chart-options-row.end {
	display:flex;
	justify-content: end;
	margin-right: 1.25rem;
    height: 4rem;
    padding-top: 1.5rem;	
}

.chart-options-col {
	display: flex;
	flex-direction: column;
	justify-content: start;
}

.chart-options-col.bottom {
	justify-content: end;
	align-items: start;
	width: 100%;
}

.btn-tertiary {
	padding: 0 0.25rem;
	height: 2.5rem;
	white-space: nowrap;
}

.category-hide {
	display: none;
}

.bar-chart-control {
	display: flex;
	align-items: center;
}

.toggle-label {
	color: var(--text-Secondary);
	font-family: var(--font-family-Title);
	font-weight: var(--font-weight-Medium);
	font-size: var(--font-size-Base);
	padding-right: .5rem;
	padding-left: 1.5rem;
}

.icon-settings {
	color: var(--icon-cta-Blue);
	margin-right:.5rem;
}

/* 1023px - iPad */
@media (max-width: 63.9375rem) {
	.chart-options {
		flex-wrap: wrap;
        align-content: space-between;
        height: 7.5rem;		
	}

	.chart-options > div {
		flex: 1 1 50%;
	}

	.chart-options-row.end {
		justify-content: start;
	}

	.bar-chart-control label{
		padding-left: 0;
	}
}

/* 767px - mobile */
@media (max-width: 47.9375rem) {
	.chart-options {
        height: 14rem;		
	}

	.chart-options-row {
		flex-wrap: wrap;
	}

	.chart-options-col {
		flex: 1 1 100%;
		padding-top: 1rem;
	}	
}
</style>